module.exports = __webpack_public_path__ + "static/media/gh.1b0a1e67.svg";